import { createContext, useContext } from "react";

const LayoutContext = createContext();

export const useLayout = () => useContext(LayoutContext);

export default LayoutContext;
